import { useTranslation } from "react-i18next";
import { DownOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Col, Row, Typography } from "antd";
import React, { ChangeEvent, KeyboardEvent } from "react";
import FormInput from "../../../../form-input/FormInput";
import { useNavigate } from "react-router-dom";
import { routesConfig } from "../../../../../config/routes";

type FilterExamTableProps = {
  modalMode?: string;
  searchValue: string;
  mode?: string | null;
  unitId?: string | null;
  selectedMode?: boolean;
  blockId?: string | null;
  courseBlockGroupIdClick?: number;
  handleOpenFilter: () => void;
  handleSubmitSearch: () => void;
  setIsOpen: (value: boolean) => void;
  handleSearch: (e: KeyboardEvent<HTMLSpanElement>) => void;
  handleChangeInput: (e: ChangeEvent<HTMLInputElement>) => void;
};

const FilterExamTable = ({
  mode,
  unitId,
  blockId,
  modalMode,
  searchValue,
  selectedMode,
  courseBlockGroupIdClick,
  setIsOpen,
  handleSearch,
  handleOpenFilter,
  handleChangeInput,
  handleSubmitSearch,
}: FilterExamTableProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <div className="heading-extra">
      <div className="heading-item heading-filter flex justify-between gap-2">
        <Button className="filter-button mr-1" onClick={handleOpenFilter}>
          <Typography.Text>{t("Bộ lọc", "Bộ lọc")}</Typography.Text>
          <DownOutlined />
        </Button>
        <div className="heading-search">
          <FormInput
            placeholder={t("Nhập tên để tìm kiếm", "Nhập tên để tìm kiếm")}
            value={searchValue}
            onChange={handleChangeInput}
            onKeyPress={handleSearch}
            afterPrefixIcon={<SearchOutlined onClick={handleSubmitSearch} />}
          />
        </div>
        <div className="heading-resigter">
          <Button
            onClick={() => {
              selectedMode
                ? navigate(
                    `/${routesConfig.courseLibrary}/${
                      routesConfig.bankQuestion
                    }?redirectUrl=${encodeURIComponent(
                      `${window.location.pathname}?unitId=${unitId}&blockId=${blockId}&mode=${mode}&courseBlockGroupIdClick=${courseBlockGroupIdClick}&action=${modalMode}`
                    )}`
                  )
                : setIsOpen(true);
            }}
            className="btn btn-primary"
          >
            <PlusOutlined />
            <Typography.Text>{t("Thêm ngân hàng", "Thêm ngân hàng")}</Typography.Text>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterExamTable;